import React from 'react';
import {Link} from 'react-router-dom';

const Footer = props => {
  const getYear = _ => {
    let year = (new Date()).getFullYear();
    // if (year <= 2017) {
    //   return 2017;
    // }
    return year;
  };

  const styles = {
    footer: {
      textAlign: 'center',
      color: '#ffffff',
      fontSize: '0.9rem',
      display: 'flex',
      gap: '1rem',
    },
    privacy_terms: {
      textDecoration: 'none',
      color: '#ffffff',
      marginLeft: 20
    }
  };

  return (
    <div>
      <div style={styles.footer}>
       <div> &copy; { getYear() } KNKT</div>
       <div>
          <a style={styles.privacy_terms} href="/privacy">Privacy</a> &nbsp;
          <a style={styles.privacy_terms} href="/terms">Terms</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;